import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppShell from './AppShell';
import { API_BASE_URL } from '../config/api';
import { ChevronLeft } from 'lucide-react';
import './Login.css';
import './LoginMethod.css';

/**
 * 非微信环境：展示开放平台「扫码登录」页面（iframe 嵌入 qrconnect）
 */
const WeChatQrLogin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [url, setUrl] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API_BASE_URL}/auth/wechat/start?mode=qr`);
        const j = await r.json();
        if (cancelled) return;
        if (j.success && j.data?.url) {
          setUrl(j.data.url as string);
        } else {
          setErr((j as { error?: string }).error || '无法加载微信登录');
        }
      } catch {
        if (!cancelled) setErr('网络错误');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const openInWindow = () => {
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <AppShell centerBody>
      <div className="login-box wechat-qr-wrap">
        <div className="login-flow-back-row">
          <button type="button" className="login-method-back login-method-back--top" onClick={() => navigate('/sign-in', { state: location.state })}>
            <ChevronLeft size={18} strokeWidth={2.25} aria-hidden />
            <span>返回</span>
          </button>
        </div>
        <h2>微信扫码登录</h2>
        <p style={{ fontSize: 14, color: '#666', marginTop: 8 }}>请使用微信扫描下方二维码完成登录</p>
        {err ? (
          <p className="wechat-done-msg wechat-done-err">{err}</p>
        ) : url ? (
          <>
            <iframe title="微信登录" className="wechat-qr-frame" src={url} />
            <div className="wechat-qr-fallback">
              <button type="button" onClick={openInWindow}>
                若无法显示，点击在新窗口打开
              </button>
            </div>
          </>
        ) : (
          <p className="wechat-done-msg">加载中…</p>
        )}
        <button type="button" className="login-method-back" onClick={() => navigate('/sign-in', { state: location.state })}>
          返回选择登录方式
        </button>
      </div>
    </AppShell>
  );
};

export default WeChatQrLogin;
